import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';

export const DesktopOnly = styled.div`
  display: block;

  ${breakpoint('large', { type: 'down' })} {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;

  ${breakpoint('large', { type: 'down' })} {
    display: block;
  }
`;
